import { render, staticRenderFns } from "./OrganisationMembers.vue?vue&type=template&id=23596856&"
import script from "./OrganisationMembers.vue?vue&type=script&lang=ts&"
export * from "./OrganisationMembers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports